import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["value"]

import type { CertificationDropdownOption } from "@/models/certificationService";


export default /*@__PURE__*/_defineComponent({
  __name: 'CertificationDropdown',
  props: {
    options: {},
    selectedId: {}
  },
  emits: ["update:certificationId"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("select", _mergeProps({ class: "cusc-select" }, _ctx.$attrs, {
    name: "certificationId",
    value: __props.selectedId,
    onChange: _cache[0] || (_cache[0] = ($event: any) => (emit('update:certificationId', Number(($event.target as HTMLSelectElement).value))))
  }), [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
      return (_openBlock(), _createElementBlock("option", {
        value: option?.id,
        key: option?.id
      }, " Cert. #" + _toDisplayString(option.sequenceNumber) + " - " + _toDisplayString(option?.amount) + " - " + _toDisplayString(option?.status), 9, _hoisted_2))
    }), 128))
  ], 16, _hoisted_1))
}
}

})